import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FiMenu } from 'react-icons/fi';
import Menu from '../NavMenu';
import {
  Container,
  Wrapper,
  NavMenu,
  NavItem,
  WrapMenu,
} from './styles';

export default class Navbar extends Component {
  state = {
    showMenu: false,
    style: {
      borderBottom: '4px solid #5e17eb',
    }
  }

  handleMenuShow = () => {
    const { showMenu } = this.state;

    this.setState({
      showMenu: !showMenu,
    }, () => {
      document.addEventListener('click', this.handleMenuClose);
    });
  }

  handleMenuClose = () => {
    this.setState({
      showMenu: false,
    }, () => {
      document.removeEventListener('click', this.handleMenuClose);
    });
  }

  render() {
    const { style, showMenu} = this.state;
    
    return (
      <Container>
        <Wrapper>
          <NavMenu menu={showMenu}>
            <NavItem>
              <HashLink 
                to="/"
              >
                <span>Bia Chacon</span>
              </HashLink>
            </NavItem>
            <NavItem>
              <NavLink exact to="/" activeStyle={style}>HOME</NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/about" activeStyle={style}>ABOUT ME</NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/skills" activeStyle={style}>SKILLS</NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/projects" activeStyle={style}>PROJECTS</NavLink>
            </NavItem>
            <NavItem>
              <HashLink to="/#contact" activeStyle={style}>CONTACT</HashLink>
            </NavItem>
            <NavItem>
              <WrapMenu>
                <Link onClick={this.handleMenuShow}>
                  <FiMenu />
                  {
                    showMenu ? <Menu /> : null
                  }
                </Link>
              </WrapMenu>
            </NavItem>
          </NavMenu>
        </Wrapper>
      </Container>
    );
  }
}